var selector = {
  searchIconButton: '[data-search-drawer]',
  resultContainer: '[data-search-result]',
  searchInput: '[data-searchbar__input]',
  searchForm: '[data-mg-search]',
  searchClose: '[data-search-close]',
  recentSearchClear: '[data-recent-clear]'
};

var formSearch = document.querySelectorAll(selector.searchForm);
var formDestination = '/search';

Array.from(formSearch).forEach(function (form) {
  formDestination = form.getAttribute('action') || '/search';
  form.addEventListener('submit', function (event) {
    var searchTerm = event.target.elements.q ? event.target.elements.q.value : '';
    if (searchTerm.replace(/\s/g, '').length > 0) __setRecentSearch(searchTerm);
  });
});

function openSearchDrawer(trigger) {
  var searchDrawer = document.querySelector('.searchbar');
  var searchInput = document.querySelector(selector.searchInput);
  if (!searchDrawer || !searchInput) {
    window.location.href = (trigger && trigger.getAttribute('href')) || '/search';
    return;
  }
  searchDrawer.classList.add('search-drawer-active');
  searchDrawer.style.visibility = 'visible';
  searchDrawer.style.opacity = '1';
  searchDrawer.style.pointerEvents = 'auto';
  searchDrawer.setAttribute('aria-hidden', 'false');
  document.body.classList.add('no-scroll');
  var recentSearch = document.querySelector('[data-recent-search]');
  if (__getRecentSearch() && recentSearch) {
    recentSearch.innerHTML = __getRecentSearch();
    __clearRecentSearch();
    recentSearch.classList.remove('hidden');
  }
  window.previousFocusElement = trigger;
  if (typeof window.focusElementsRotation === 'function') window.focusElementsRotation(searchDrawer);
  searchInput.value = '';
  searchInput.setAttribute('tabindex', '0');
  window.setTimeout(function () { searchInput.focus(); }, 100);
  __searchResult('');
}

function closeSearchDrawer() {
  var searchDrawer = document.querySelector('.searchbar');
  if (!searchDrawer) return;
  if (typeof window.stopFocusRotation === 'function') window.stopFocusRotation();
  if (window.previousFocusElement && typeof window.previousFocusElement.focus === 'function') window.previousFocusElement.focus();
  window.previousFocusElement = null;
  searchDrawer.classList.remove('search-drawer-active');
  searchDrawer.style.visibility = '';
  searchDrawer.style.opacity = '';
  searchDrawer.style.pointerEvents = '';
  searchDrawer.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('no-scroll');
}

Array.from(document.querySelectorAll(selector.searchIconButton)).forEach(function (searchSelector) {
  searchSelector.addEventListener('click', function (event) {
    event.preventDefault();
    var searchDrawer = document.querySelector('.searchbar');
    if (searchDrawer && searchDrawer.classList.contains('search-drawer-active')) closeSearchDrawer();
    else openSearchDrawer(searchSelector);
  });
  searchSelector.addEventListener('keydown', function () { document.body.classList.add('tab-focus'); });
});
Array.from(document.querySelectorAll(selector.searchClose)).forEach(function (searchClose) {
  searchClose.addEventListener('click', function (event) { event.preventDefault(); closeSearchDrawer(); });
});

var searchInput = document.querySelector(selector.searchInput);
var searchTyping;
if (searchInput) {
  searchInput.addEventListener('keyup', function () {
    clearTimeout(searchTyping);
    searchTyping = setTimeout(function () {
      var searchTerm = searchInput.value;
      if (searchTerm.replace(/\s/g, '').length > 0) __setRecentSearch(searchTerm);
      __searchResult(searchTerm);
    }, 500);
  });
}

function __searchResult(searchTerm) {
  var resultContainer = document.querySelector(selector.resultContainer);
  if (!resultContainer) return;
  var recentSearch = document.querySelector('[data-recent-search]');
  if (searchTerm.replace(/\s/g, '').length === 0) {
    resultContainer.innerHTML = '';
    if (__getRecentSearch() && recentSearch) {
      recentSearch.innerHTML = __getRecentSearch();
      __clearRecentSearch();
      recentSearch.classList.remove('hidden');
    }
    return;
  }
  if (typeof window.preLoadLoadGif !== 'undefined') resultContainer.innerHTML = window.preLoadLoadGif;
  fetch(formDestination + '/suggest?section_id=predictive-search&q=' + encodeURIComponent(searchTerm))
    .then(function (response) { return response.text(); })
    .then(function (responseText) {
      var resultsMarkup = new DOMParser().parseFromString(responseText, 'text/html');
      var predictiveSection = resultsMarkup.querySelector('#shopify-section-predictive-search');
      if (!predictiveSection) throw new Error('Predictive search response was invalid.');
      resultContainer.innerHTML = predictiveSection.innerHTML;
      if (recentSearch) recentSearch.classList.add('hidden');
      if (typeof window.animationStatus !== 'undefined' && window.animationStatus && window.AOS) window.AOS.refreshHard();
    })
    .catch(function () { resultContainer.innerHTML = '<p class="searchbar__no-results">Search suggestions are temporarily unavailable. Press Enter to view results.</p>'; });
}

function __setRecentSearch(searchItem) {
  var localStorageValue = JSON.parse(localStorage.getItem('recent-search')) || [];
  if (localStorageValue.indexOf(searchItem) < 0) {
    if (localStorageValue.length >= 20) localStorageValue.shift();
    localStorageValue.push(searchItem);
    localStorage.setItem('recent-search', JSON.stringify(localStorageValue));
  }
}
function __clearRecentSearch() {
  var clearButton = document.querySelector(selector.recentSearchClear);
  var recentSearch = document.querySelector('[data-recent-search]');
  if (clearButton && !clearButton.dataset.clearBound) {
    clearButton.dataset.clearBound = 'true';
    clearButton.addEventListener('click', function (event) {
      event.preventDefault(); localStorage.removeItem('recent-search');
      if (recentSearch) recentSearch.classList.add('hidden');
    });
  }
}
function __getRecentSearch() {
  var localStorageValue = JSON.parse(localStorage.getItem('recent-search')) || [];
  if (!localStorageValue.length) return '';
  var recentHtml = '<h6 class="searchbar__recent-heading text-small">Recent Search</h6><ul class="list-unstyled recent__list">';
  localStorageValue.slice().reverse().forEach(function (recent) {
    if (recent) recentHtml += '<li class="recent__list-item"><a class="recent__list-link unstyled-link" href="/search?q=' + encodeURIComponent(recent) + '">' + recent.replace(/[&<>"']/g, function (character) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[character]; }) + '</a></li>';
  });
  return recentHtml + '<li class="recent__list-item clear-recent" data-recent-clear><a class="recent__list-link unstyled-link" href="#">Clear</a></li></ul>';
}
